"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icdRiskCategoryDictionaryResponse = exports.icdRiskCategoryRowValues = void 0;
exports.icdRiskCategoryRowValues = [
    {
        ROLE: "PRIMARY ICD/MEDICAL NECESSITY",
        "ACCEPTABILITY BY STAR USE CASE": "3, 4, 5",
        CATEGORY: "CORRECT",
        ASSESSMENT: "IDEAL ICD"
    },
    {
        ROLE: "PRIMARY ICD/MEDICAL NECESSITY",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "INCORRECT SEQUENCING FOR NON-PRIMARY ICD"
    },
    {
        ROLE: "ASSIGN ROLE (SIGN/SYMPTOM, INCIDENTAL, HISTORY OF, STATUS OF, EXTERNAL CAUSE, SDoH)",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "UNNECESSARY ICD (ASSIGN ROLE)"
    },
    {
        ROLE: "PRIMARY ICD/MEDICAL NECESSITY",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "UNSPECIFIED ICD (MORE SPECIFIC CODE IS DOCUMENTED)"
    },
    {
        ROLE: "PRIMARY ICD/MEDICAL NECESSITY",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "NON-PRIMARY ICD SHOULD BE PRIMARY"
    },
    {
        ROLE: "GUIDELINE VIOLATION",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "ICD GUIDELINE ERROR (EXCLUDES 1, CODE FIRST, ETC)"
    },
    {
        ROLE: "GUIDELINE VIOLATION",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "INVALID AS PRIMARY"
    },
    {
        ROLE: "INCIDENTAL FINDINGS",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "INCIDENTAL FINDING AS PRIMARY"
    },
    {
        ROLE: "ERROR",
        "ACCEPTABILITY BY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "HISTORY OF VS CURRENT CANCER"
    },
    {
        ROLE: "ERROR",
        "ACCEPTABILITY BY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "WRONG SPECIFICITY OR LATERALITY"
    },
    {
        ROLE: "UNCERTAIN",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "SIGN/SYMPTOM UNCERTAIN"
    },
    {
        ROLE: "ERROR",
        "ACCEPTABILITY BY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "SIGN/SYMPTOM NOT DOCUMENTED"
    },
    {
        ROLE: "UNCERTAIN",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "OTHER DIAGNOSIS UNCERTAIN"
    },
    {
        ROLE: "ERROR",
        "ACCEPTABILITY BY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "OTHER DIAGNOSIS NOT DOCUMENTED"
    },
    {
        ROLE: "UNCERTAIN",
        "ACCEPTABILITY BY STAR USE CASE": "5",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "CANCER/AIDS/STDS UNCERTAIN"
    },
    {
        ROLE: "ERROR",
        "ACCEPTABILITY BY STAR USE CASE": "NO",
        CATEGORY: "INCORRECT",
        ASSESSMENT: "CANCER/AIDS/STDS NOT DOCUMENTED"
    },
    {
        ROLE: "PRIMARY ICD/MEDICAL NECESSITY",
        "ACCEPTABILITY BY STAR USE CASE": "NO",
        CATEGORY: "MISSED",
        ASSESSMENT: "PRIMARY ICD (CHIEF COMPLAINT, IMPRESSION, FINDING, ETC)"
    },
    {
        ROLE: "PRIMARY ICD/MEDICAL NECESSITY",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "MEDICAL NECESSITY/ADDITIONAL DIAGNOSTIC FINDING (PATH DIAGNOSIS, RAD IMPRESSION)"
    },
    {
        ROLE: "INCIDENTAL FINDINGS",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "INCIDENTAL FINDING"
    },
    {
        ROLE: "HISTORY OF/STATUS",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "HISTORY OR STATUS (UNRELATED TO CLINICAL INDICATION)"
    },
    {
        ROLE: "SIGN OR SYMPTOM",
        "ACCEPTABILITY BY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "SIGN OR SYMPTOM (WHEN RELATED DIAGNOSIS IS DOCUMENTED)"
    },
    {
        ROLE: "EXTERNAL CAUSE",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "EXTERNAL CAUSES OF MORBIDITY"
    },
    {
        ROLE: "SDoH",
        "ACCEPTABILITY BY STAR USE CASE": "3",
        CATEGORY: "MISSED",
        ASSESSMENT: "SOCIAL DETERMINANTS OF HEALTH"
    },
    {
        ROLE: "RESOLVED DIAGNOSIS",
        "ACCEPTABILITY BY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "DIAGNOSIS IS DOCUMENTED AS RESOLVED"
    },
    {
        ROLE: "UNCERTAIN",
        "ACCEPTABILITY BY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "DIAGNOSIS IS DOCUMENTED AS UNCERTAIN, RULE OUT, ETC"
    },
    {
        ROLE: "CHRONIC BUT UNTREATED",
        "ACCEPTABILITY BY STAR USE CASE": "3, 4",
        CATEGORY: "MISSED",
        ASSESSMENT: "DIAGNOSIS IS DOCUMENTED BUT UNTREATED AT THIS ENCOUNTER (MEAT, TEAMS)"
    }
];
exports.icdRiskCategoryDictionaryResponse = {
    numRows: 26,
    columnNames: [
        "ROLE",
        "ASSESSMENT",
        "CATEGORY",
        "ACCEPTABILITY BY STAR USE CASE"
    ],
    rowValues: exports.icdRiskCategoryRowValues
};
//# sourceMappingURL=icd-risk-categories.js.map